export class Blog {

	// constructor() {}

	loadMore(parent)
	{
		let btn = $(parent);
		btn.addClass('loading');
		btn.prop('disabled', true);
		let p = btn.attr('data-next');

		$.ajax({
			url: "/ajax.php?mid=6",
			type: 'GET',
			data: $('.blog-teaser__search').serialize() + '&p=' + p,
			dataType: "json",
			success: function(res)
			{
				if(res.html) 
				{
					$('.blog-table__list').append(res.html);
					if (res.count > res.position)
					{
						btn.attr('data-next', res.position * 1 + 1);
						btn.removeClass('loading');
						btn.prop('disabled', false);
					}
					else
					{
						btn.remove();
					}
				}
				else
				{
					aler(res.error)
				}
			},
			error: function(error)
			{
				alert('Ошибка отправки данных! Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта')
			}			
		})
	}

}